import React, { useState } from 'react'
import { Transforms, Range, Editor, Point } from 'slate'
import { useSlateStatic, useSlate } from 'slate-react'
import {
  cbModal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Button,
  ButtonGroup,
  Textarea,
  Field,
  FieldLabel
} from '../../../../../../index'

import { disableOnCodeChild } from '../code/utils'
import { Editor as RteEditor } from '../../../utils/types'
import { onEnter } from '../../../utils/runOnKeyDown'
import { iFrameUrl, blockQuoteUrl, isValidUrl, normalizeEmbedUrl } from './utils/index'
import styles from './style.module.css'
import '../style.css'
import { Youtube, Vimeo, Facebook, Twitter, Instagram, Tiktok } from './svgs'
import isUrl from 'is-url'


const isIframe = (data) => {
  return (data?.match(/<iframe|<video/gi) !== null);
}

const isBlockQuote = (data) => {
  return (data?.match(/<blockquote/gi) !== null);
}

const getUpdatedAttrs = (attrs, url) => {
  if (typeof attrs === 'string') {
    return {
      src: url
    }
  }
  else return { ...attrs, src: url }
}

export const addSocialEmbed = (editor, attrs) => {
  let url;
  if (typeof attrs === 'string') {
    url = attrs;
  }
  else {
    url = attrs?.src
  }
  url = normalizeEmbedUrl(url)
  if (!url || !isUrl(url)) return false
  
  let embeded = {
    type: 'social-embeds',
    attrs: getUpdatedAttrs(attrs, url),
    children: [{ text: '' }]
  }
  editor.insertNode(embeded)
}

export default (props) => {
  const editor: RteEditor = useSlateStatic()
  const useSlateEditor = useSlate()

  const handleSubmitForm = React.useCallback((values, selection) => {
    if (selection) Transforms.select(editor, selection)

    if (isIframe(values['embeded_url'])) {
      addSocialEmbed(editor, iFrameUrl(values['embeded_url']))
      return;
    }
    if (isBlockQuote(values['embeded_url'])) {
      if (blockQuoteUrl(values['embeded_url'])) {
        addSocialEmbed(editor, blockQuoteUrl(values['embeded_url']))
      }
      return;
    }
    addSocialEmbed(editor, values['embeded_url'])
  }, [])

  const openModal = () => {
    const selection: Range | Point = editor.selection || editor.savedSelection || Editor.end(editor, []);
    if (!selection) return
    cbModal({
      modalProps: {
        //@ts-ignore
        shouldReturnFocusAfterClose: false,
      },
      component: (props) => <ModalComponent handleSubmitForm={handleSubmitForm} selection={selection} {...props} />
    })
  }

  const ModalComponent = (props) => {
    const [formData, setFormData] = useState({
      embeded_url: ''
    })

    const handleChange = (e) => {
      e.persist()
      setFormData((prevState) => {
        return {
          ...prevState,
          [e.target.name]: e.target.value
        }
      })
    }

    const handleSubmit = (e) => {
      props.handleSubmitForm(formData, props.selection)
      props.closeModal()
    }

    return (
      <div className='cs-auto-draft-modal'
        onKeyDown={(event) =>
          onEnter(event, () => {
            handleSubmit(event)
          })
        }>
        <ModalHeader title="Social Embeds" closeModal={props.closeModal} />

        <ModalBody>
          <div className='FormFields'>
            <Field>
              <FieldLabel version='v2' htmlFor='embeded_url'>Embed URL</FieldLabel>
              <Textarea
                version="v2"
                autoFocus
                name="embeded_url"
                placeholder="Enter Embeded URL"
                type="url"
                value={formData.embeded_url}
                onChange={handleChange}
                data-testid="social_embed_url"
              />
            </Field>
          </div>
          <div className={styles['field-style']}>
            <Field labelText="Allowed Embeds:">
              <div className={styles['embed-icons-container']}>
                <div><Youtube /></div>
                <div><Vimeo /></div>
                <div><Facebook /></div>
                <div><Twitter /></div>
                <div><Instagram /></div>
                <div><Tiktok /></div>
              </div>
            </Field>
          </div>
        </ModalBody>

        <ModalFooter>
          <ButtonGroup>
            <Button version='v2' key="cancel" buttonType="tertiary" onClick={() => props.closeModal()}>
              Cancel
            </Button>
            <Button version='v2' key="add" onClick={handleSubmit} data-testid="addSocialEmbedBtn">
              Add
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </div>
    )
  }

  return (
    <React.Fragment>
      {props.children({
        handleMouseDown: openModal,
        isDisable: {
          func: disableOnCodeChild,
          params: { editor: useSlateEditor }
        }
      })}
    </React.Fragment>
  )
}

